// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointmentScheduler_submitBtn__Bpj8F {
  color: #000000 !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  letter-spacing: normal !important;
  text-align: center !important;
  background:  rgba(30, 229, 118, 1)  !important;
  padding: 16px !important;
  border-radius: 100px !important;
  border: none !important;
  cursor: pointer !important;
  margin-top: 0;
}

:root {
  --accent-green:  rgba(30, 229, 118, 1) ; /* same as submitBtn */
  --text-dark: #000000;
  --table-bg: #ffffff;
  --table-header-bg: #046A38;
  --table-header-border: rgba(30, 229, 118, 0.30);
  --table-row-hover: rgba(30, 229, 118, 0.08);
  --table-border: #e9ecef; /* close to Bootstrap's border color */
  --table-row-odd: #CEE5CB;
  --table-row-even: #ECF3EB;
}

.appointmentScheduler_table-theme__eK9Wv {
  font-family: "DM Sans", sans-serif;
  color: var(--text-dark);
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table-card__H1Q4I {
  background: var(--table-bg);
  border: 1px solid var(--table-border);
  /* border-radius: 16px; */
  box-shadow: 0 8px 24px rgba(0,0,0,0.06);
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 {
  margin: 0;
  border-collapse: separate;       
  border-spacing: 0;
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 thead th {
  background: var(--table-header-bg);
  border-bottom: 2px solid var(--table-header-border);
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
  text-transform: none;
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 tbody td,
.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 thead th {
  padding: 8px 16px; /* visually aligned with your button’s comfort spacing */
}
.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 tbody tr:nth-child(odd) {
  background: var(--table-row-odd);
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 tbody tr:nth-child(even) {
  background: var(--table-row-even);
}
.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 tbody tr:hover {
  background: var(--table-row-hover);
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 tbody tr + tr td {
  border-top: 1px solid var(--table-border);
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 tbody td.appointmentScheduler_id-col__oYclN {
  color: var(--text-dark);
  font-weight: 500;
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_badge-accent__8N7\\+5 {
  display: inline-block;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #0f7a4d; /* readable on light background */
  background: rgba(30, 229, 118, 0.18);
  border: 1px solid rgba(30, 229, 118, 0.35);
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_btn-outline-accent__Mt7-P {
  color: var(--text-dark);
  border-radius: 100px;
  border: 1px solid rgba(0,0,0,0.12);
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  background: #fff;
}
.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_btn-outline-accent__Mt7-P:hover {
  border-color: rgba(30, 229, 118, 0.8);
  color: #0f7a4d;
  background: rgba(30, 229, 118, 0.08);
}

.appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_btn-accent__TcQ-U {
  color: var(--text-dark) !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  text-align: center !important;
  background: var(--accent-green) !important;
  padding: 10px 18px;                
  border-radius: 100px !important;
  border: none !important;
  cursor: pointer !important;
}

@media (max-width: 576px) {
  .appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 thead th,
  .appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 tbody td {
    padding: 12px 12px;
    font-size: 13px;
  }
  .appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 thead th:last-child,
  .appointmentScheduler_table-theme__eK9Wv .appointmentScheduler_table__mJbr9 tbody td:last-child {
    white-space: nowrap;
  }
}
.appointmentScheduler_bg-green__V2HPP{
      background-color:  rgba(30, 229, 118, 1)  !important;
    border: none !important;
    color: #000000 !important;
}
.appointmentScheduler_text-align-end__FZ0OZ{
    text-align: end;
}
.appointmentScheduler_pagination__N8YMs {
  float: right;
  margin: 3%;
}
.appointmentScheduler_pagination__N8YMs .appointmentScheduler_page-btn__sEK0c {
    border: 0.3px solid #ccc;
    font-size: larger;
    border-radius: 5px;
    background: #fff;
    color: #4f785f;
    font-weight: 500;
    padding: 0.1em 0.5em;
}

/**View Modal*/
.appointmentScheduler_detailRow__1TAnI {
  display: flex;
  gap: 12px;
  margin-bottom: 10px;
}

.appointmentScheduler_label__9QRxd {
  font-weight: 600;
  min-width: 160px;
}

.appointmentScheduler_value__30qP0 {
  color: #333;
}
/**View Modal*/

/**Pagination **/
.appointmentScheduler_pagination-wrapper__3hKxt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding: 16px 0;
  flex-wrap: wrap;
  gap: 16px;
}

.appointmentScheduler_pagination__N8YMs {
  display: flex;
  gap: 8px;
  align-items: center;
}

.appointmentScheduler_page-btn__sEK0c {
  border: 1px solid #e5e7eb;
  padding: 0;
  border-radius: 8px;
  cursor: pointer;
  background-color: #fff;
  color: #374151;
  transition: all 0.2s ease;
  min-height: 40px;
  min-width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
}

.appointmentScheduler_page-btn__sEK0c:hover:not(:disabled):not(.appointmentScheduler_active__E9nWw) {
  background-color: rgba(30, 229, 118, 0.08);
  border-color: rgba(30, 229, 118, 0.3);
  color: #046A38;
}

.appointmentScheduler_page-btn__sEK0c.appointmentScheduler_active__E9nWw {
  background-color: #046A38;
  color: #ffffff;
  border-color: #046A38;
  font-weight: 600;
}

.appointmentScheduler_page-btn__sEK0c:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.appointmentScheduler_nav-btn__ysb8h {
  border-radius: 8px;
  padding: 0;
}

.appointmentScheduler_nav-btn__ysb8h svg {
  display: block;
}

.appointmentScheduler_ellipsis__5Ozl3 {
  color: #9ca3af;
  padding: 0 4px;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}

.appointmentScheduler_pagination-info__CUb\\+Z {
  color: #6b7280;
  font-size: 14px;
  font-weight: 400;
  font-family: "DM Sans", sans-serif;
}

@media (max-width: 640px) {
  .appointmentScheduler_pagination-wrapper__3hKxt {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .appointmentScheduler_pagination-info__CUb\\+Z {
    order: -1;
    width: 100%;
  }
}
/**Pagination**/`, "",{"version":3,"sources":["webpack://./src/styles/userDetails/appointmentScheduler.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,8CAA8C;EAC9C,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,uCAAuC,EAAE,sBAAsB;EAC/D,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,+CAA+C;EAC/C,2CAA2C;EAC3C,uBAAuB,EAAE,sCAAsC;EAC/D,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,mDAAmD;EACnD,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB,EAAE,wDAAwD;AAC7E;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc,EAAE,iCAAiC;EACjD,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,kBAAkB;IAClB,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;AACF;AACA;MACM,oDAAoD;IACtD,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA,cAAc;;AAEd,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA,eAAe","sourcesContent":[".submitBtn {\n  color: #000000 !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  letter-spacing: normal !important;\n  text-align: center !important;\n  background:  rgba(30, 229, 118, 1)  !important;\n  padding: 16px !important;\n  border-radius: 100px !important;\n  border: none !important;\n  cursor: pointer !important;\n  margin-top: 0;\n}\n\n:root {\n  --accent-green:  rgba(30, 229, 118, 1) ; /* same as submitBtn */\n  --text-dark: #000000;\n  --table-bg: #ffffff;\n  --table-header-bg: #046A38;\n  --table-header-border: rgba(30, 229, 118, 0.30);\n  --table-row-hover: rgba(30, 229, 118, 0.08);\n  --table-border: #e9ecef; /* close to Bootstrap's border color */\n  --table-row-odd: #CEE5CB;\n  --table-row-even: #ECF3EB;\n}\n\n.table-theme {\n  font-family: \"DM Sans\", sans-serif;\n  color: var(--text-dark);\n}\n\n.table-theme .table-card {\n  background: var(--table-bg);\n  border: 1px solid var(--table-border);\n  /* border-radius: 16px; */\n  box-shadow: 0 8px 24px rgba(0,0,0,0.06);\n}\n\n.table-theme .table {\n  margin: 0;\n  border-collapse: separate;       \n  border-spacing: 0;\n}\n\n.table-theme .table thead th {\n  background: var(--table-header-bg);\n  border-bottom: 2px solid var(--table-header-border);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0.2px;\n  text-transform: none;\n}\n\n.table-theme .table tbody td,\n.table-theme .table thead th {\n  padding: 8px 16px; /* visually aligned with your button’s comfort spacing */\n}\n.table-theme .table tbody tr:nth-child(odd) {\n  background: var(--table-row-odd);\n}\n\n.table-theme .table tbody tr:nth-child(even) {\n  background: var(--table-row-even);\n}\n.table-theme .table tbody tr:hover {\n  background: var(--table-row-hover);\n}\n\n.table-theme .table tbody tr + tr td {\n  border-top: 1px solid var(--table-border);\n}\n\n.table-theme .table tbody td.id-col {\n  color: var(--text-dark);\n  font-weight: 500;\n}\n\n.table-theme .badge-accent {\n  display: inline-block;\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #0f7a4d; /* readable on light background */\n  background: rgba(30, 229, 118, 0.18);\n  border: 1px solid rgba(30, 229, 118, 0.35);\n}\n\n.table-theme .btn-outline-accent {\n  color: var(--text-dark);\n  border-radius: 100px;\n  border: 1px solid rgba(0,0,0,0.12);\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  background: #fff;\n}\n.table-theme .btn-outline-accent:hover {\n  border-color: rgba(30, 229, 118, 0.8);\n  color: #0f7a4d;\n  background: rgba(30, 229, 118, 0.08);\n}\n\n.table-theme .btn-accent {\n  color: var(--text-dark) !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  text-align: center !important;\n  background: var(--accent-green) !important;\n  padding: 10px 18px;                \n  border-radius: 100px !important;\n  border: none !important;\n  cursor: pointer !important;\n}\n\n@media (max-width: 576px) {\n  .table-theme .table thead th,\n  .table-theme .table tbody td {\n    padding: 12px 12px;\n    font-size: 13px;\n  }\n  .table-theme .table thead th:last-child,\n  .table-theme .table tbody td:last-child {\n    white-space: nowrap;\n  }\n}\n.bg-green{\n      background-color:  rgba(30, 229, 118, 1)  !important;\n    border: none !important;\n    color: #000000 !important;\n}\n.text-align-end{\n    text-align: end;\n}\n.pagination {\n  float: right;\n  margin: 3%;\n}\n.pagination .page-btn {\n    border: 0.3px solid #ccc;\n    font-size: larger;\n    border-radius: 5px;\n    background: #fff;\n    color: #4f785f;\n    font-weight: 500;\n    padding: 0.1em 0.5em;\n}\n\n/**View Modal*/\n.detailRow {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.label {\n  font-weight: 600;\n  min-width: 160px;\n}\n\n.value {\n  color: #333;\n}\n/**View Modal*/\n\n/**Pagination **/\n.pagination-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 24px;\n  padding: 16px 0;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.pagination {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.page-btn {\n  border: 1px solid #e5e7eb;\n  padding: 0;\n  border-radius: 8px;\n  cursor: pointer;\n  background-color: #fff;\n  color: #374151;\n  transition: all 0.2s ease;\n  min-height: 40px;\n  min-width: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"DM Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.page-btn:hover:not(:disabled):not(.active) {\n  background-color: rgba(30, 229, 118, 0.08);\n  border-color: rgba(30, 229, 118, 0.3);\n  color: #046A38;\n}\n\n.page-btn.active {\n  background-color: #046A38;\n  color: #ffffff;\n  border-color: #046A38;\n  font-weight: 600;\n}\n\n.page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.nav-btn {\n  border-radius: 8px;\n  padding: 0;\n}\n\n.nav-btn svg {\n  display: block;\n}\n\n.ellipsis {\n  color: #9ca3af;\n  padding: 0 4px;\n  font-size: 14px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n}\n\n.pagination-info {\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: \"DM Sans\", sans-serif;\n}\n\n@media (max-width: 640px) {\n  .pagination-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .pagination-info {\n    order: -1;\n    width: 100%;\n  }\n}\n/**Pagination**/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submitBtn": `appointmentScheduler_submitBtn__Bpj8F`,
	"table-theme": `appointmentScheduler_table-theme__eK9Wv`,
	"table-card": `appointmentScheduler_table-card__H1Q4I`,
	"table": `appointmentScheduler_table__mJbr9`,
	"id-col": `appointmentScheduler_id-col__oYclN`,
	"badge-accent": `appointmentScheduler_badge-accent__8N7+5`,
	"btn-outline-accent": `appointmentScheduler_btn-outline-accent__Mt7-P`,
	"btn-accent": `appointmentScheduler_btn-accent__TcQ-U`,
	"bg-green": `appointmentScheduler_bg-green__V2HPP`,
	"text-align-end": `appointmentScheduler_text-align-end__FZ0OZ`,
	"pagination": `appointmentScheduler_pagination__N8YMs`,
	"page-btn": `appointmentScheduler_page-btn__sEK0c`,
	"detailRow": `appointmentScheduler_detailRow__1TAnI`,
	"label": `appointmentScheduler_label__9QRxd`,
	"value": `appointmentScheduler_value__30qP0`,
	"pagination-wrapper": `appointmentScheduler_pagination-wrapper__3hKxt`,
	"active": `appointmentScheduler_active__E9nWw`,
	"nav-btn": `appointmentScheduler_nav-btn__ysb8h`,
	"ellipsis": `appointmentScheduler_ellipsis__5Ozl3`,
	"pagination-info": `appointmentScheduler_pagination-info__CUb+Z`
};
export default ___CSS_LOADER_EXPORT___;
